var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpsFeatures2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.3 141.58C487.76 102.01 497.45 80.03 499.39 75.64C501.33 71.76 499.39 67.88 495.52 65.94C481.55 59.44 369.84 7.47 355.88 0.97C352 -0.97 348.12 0.97 346.18 4.85C344.44 8.79 335.71 28.51 320 64C304.29 28.51 295.56 8.79 293.82 4.85C291.88 0.97 288 -0.97 284.12 0.97C270.16 7.47 158.45 59.44 144.48 65.94C140.61 67.88 139.64 71.76 140.61 75.64C142.55 80.03 152.24 102.01 169.7 141.58C83.59 141.58 35.75 141.58 26.18 141.58C22.3 141.58 18.42 144.48 18.42 149.33C18.42 190.74 18.42 521.99 18.42 563.39C18.42 567.27 21.33 571.15 26.18 571.15C40.99 571.15 115.01 571.15 248.24 571.15L223.03 625.45L183.27 625.45C183.27 634.18 183.27 639.03 183.27 640C302.55 640 328.73 640 459.64 640C459.64 639.03 459.64 634.18 459.64 625.45L419.88 625.45L394.67 571.15C527.9 571.15 601.92 571.15 616.73 571.15C620.61 571.15 624.48 568.24 624.48 563.39C624.48 521.99 624.48 190.74 624.48 149.33C621.58 145.45 617.7 141.58 613.82 141.58C594.68 141.58 546.84 141.58 470.3 141.58ZM452.85 352L327.76 410.18L327.76 247.27C338.81 272.87 344.95 287.09 346.18 289.94C348.12 293.82 352 295.76 355.88 293.82C362.34 290.84 394.67 275.98 452.85 249.21L452.85 352ZM187.15 352L187.15 249.21C245.33 276.56 277.66 291.75 284.12 294.79C288 296.73 291.88 294.79 293.82 290.91C295.05 288.06 301.19 273.84 312.24 248.24L312.24 410.18L187.15 352ZM320 204.61L196.85 147.39L320 90.18L443.15 147.39L320 204.61ZM310.3 216.24C294.01 252.9 284.96 273.26 283.15 277.33C217.21 246.3 163.88 222.06 156.12 218.18C157.93 214.11 166.98 193.75 183.27 157.09L310.3 216.24ZM172.61 242.42C172.61 310.5 172.61 348.32 172.61 355.88C172.61 358.79 174.55 361.7 176.48 362.67C190.45 369.16 302.16 421.14 316.12 427.64C318.06 428.61 320 428.61 321.94 427.64C335.9 421.14 447.61 369.16 461.58 362.67C464.48 361.7 465.45 358.79 465.45 355.88C465.45 348.32 465.45 310.5 465.45 242.42C482.33 234.28 491.7 229.75 493.58 228.85C497.45 226.91 498.42 223.03 497.45 219.15C496.74 217.54 493.19 209.45 486.79 194.91L566.3 194.91L566.3 497.45L71.76 497.45L71.76 194.91L151.27 194.91C144.87 209.45 141.32 217.54 140.61 219.15C138.67 223.03 140.61 226.91 144.48 228.85C148.23 230.66 157.61 235.18 172.61 242.42ZM355.88 278.3C354.13 274.17 345.41 253.48 329.7 216.24L456.73 157.09L482.91 219.15C506.18 208.16 463.84 227.88 355.88 278.3ZM482.91 76.61L455.76 137.7L329.7 78.55L355.88 17.45L482.91 76.61ZM310.3 78.55L183.27 137.7L156.12 76.61L284.12 17.45L310.3 78.55ZM237.58 625.45L262.79 571.15L375.27 571.15L402.42 625.45L237.58 625.45ZM32.97 555.64C32.97 529 32.97 395.83 32.97 156.12L167.76 156.12L157.09 180.36C101.82 180.36 71.11 180.36 64.97 180.36C61.09 180.36 57.21 183.27 57.21 188.12C57.21 219.83 57.21 473.5 57.21 505.21C57.21 509.09 60.12 512.97 64.97 512.97C116.07 512.97 524.9 512.97 576 512.97C579.88 512.97 583.76 510.06 583.76 505.21C583.76 473.5 583.76 219.83 583.76 188.12C583.76 184.24 580.85 180.36 576 180.36C569.79 180.36 538.76 180.36 482.91 180.36L472.24 156.12L607.03 156.12L607.03 555.64C455.76 555.64 264.4 555.64 32.97 555.64Z",
    id: "b1qk4rSEgD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89 527.52C281.89 527.52 281.89 527.52 281.89 527.52C281.89 536.24 281.89 541.09 281.89 542.06C281.89 542.06 281.89 542.06 281.89 542.06C266.18 542.06 257.45 542.06 255.71 542.06C255.71 542.06 255.71 542.06 255.71 542.06C255.71 533.33 255.71 528.48 255.71 527.52C255.71 527.52 255.71 527.52 255.71 527.52C271.42 527.52 280.15 527.52 281.89 527.52Z",
    id: "f1vIBYPId2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09 527.52C333.09 527.52 333.09 527.52 333.09 527.52C333.09 536.24 333.09 541.09 333.09 542.06C333.09 542.06 333.09 542.06 333.09 542.06C317.38 542.06 308.65 542.06 306.91 542.06C306.91 542.06 306.91 542.06 306.91 542.06C306.91 533.33 306.91 528.48 306.91 527.52C306.91 527.52 306.91 527.52 306.91 527.52C322.62 527.52 331.35 527.52 333.09 527.52Z",
    id: "asdIMYSqW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.85 527.52C383.85 527.52 383.85 527.52 383.85 527.52C383.85 536.24 383.85 541.09 383.85 542.06C383.85 542.06 383.85 542.06 383.85 542.06C368.14 542.06 359.41 542.06 357.67 542.06C357.67 542.06 357.67 542.06 357.67 542.06C357.67 533.33 357.67 528.48 357.67 527.52C357.67 527.52 357.67 527.52 357.67 527.52C373.38 527.52 382.1 527.52 383.85 527.52Z",
    id: "c1CQUe7UfL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 527.52C434 527.52 434 527.52 434 527.52C434 536.24 434 541.09 434 542.06C434 542.06 434 542.06 434 542.06C418.29 542.06 409.56 542.06 407.82 542.06C407.82 542.06 407.82 542.06 407.82 542.06C407.82 533.33 407.82 528.48 407.82 527.52C407.82 527.52 407.82 527.52 407.82 527.52C423.53 527.52 432.25 527.52 434 527.52Z",
    id: "a1HItUMmOR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66 527.52C229.66 527.52 229.66 527.52 229.66 527.52C229.66 536.24 229.66 541.09 229.66 542.06C229.66 542.06 229.66 542.06 229.66 542.06C213.96 542.06 205.23 542.06 203.48 542.06C203.48 542.06 203.48 542.06 203.48 542.06C203.48 533.33 203.48 528.48 203.48 527.52C203.48 527.52 203.48 527.52 203.48 527.52C219.19 527.52 227.92 527.52 229.66 527.52Z",
    id: "b29lmcSgH"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1qk4rSEgD",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1qk4rSEgD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1vIBYPId2",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1vIBYPId2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asdIMYSqW",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asdIMYSqW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1CQUe7UfL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1CQUe7UfL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1HItUMmOR",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1HItUMmOR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b29lmcSgH",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b29lmcSgH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpsFeatures2);
export default __webpack_public_path__ + "static/media/vps-features-2.91beb08163741b4936309ee4480b3788.svg";
export { ForwardRef as ReactComponent };